// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"70":"c4df14d0","138":"8a9aa23d","314":"85b92794","787":"6a9758b6","973":"096d3cf2"}[chunkId] + ".chunk.js";
};